if (!customElements.get('td-kuya-note-spotlight')) {
  class TdKuyaNoteSpotlight extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-td-kuya-note-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-td-kuya-note-panel]'));

      if (!this.tabs.length || this.tabs.length !== this.panels.length) {
        return;
      }

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleClick);
        tab.addEventListener('keydown', this.handleKeydown);
      });

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }

      this.setAttribute('data-tabs-ready', '');
    }

    disconnectedCallback() {
      if (!this.tabs) {
        return;
      }

      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleClick);
        tab.removeEventListener('keydown', this.handleKeydown);
      });

      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleClick(event) {
      const index = this.tabs.indexOf(event.currentTarget);

      if (index >= 0) {
        this.activate(index, false);
      }
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      const lastIndex = this.tabs.length - 1;
      let nextIndex = null;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = lastIndex;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.activate(nextIndex, true);
    }

    handleBlockSelect(event) {
      const index = this.panels.indexOf(event.target);

      if (index >= 0) {
        this.activate(index, false);
      }
    }

    activate(index, moveFocus) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');

        if (selected) {
          tab.removeAttribute('tabindex');
        } else {
          tab.setAttribute('tabindex', '-1');
        }
      });

      this.panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);

        if (i === index) {
          panel.setAttribute('tabindex', '0');
        } else {
          panel.removeAttribute('tabindex');
        }
      });

      if (moveFocus) {
        this.tabs[index].focus();
      }
    }
  }

  customElements.define('td-kuya-note-spotlight', TdKuyaNoteSpotlight);
}
